module.exports = __webpack_public_path__ + "img/ring_y_skip_0_1@3x.1c45b52a.png";